// import DashboardIcon from '@mui/icons-material/Dashboard';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import BarChartIcon from '@mui/icons-material/BarChart';
import DescriptionIcon from '@mui/icons-material/Description';
// import LayersIcon from '@mui/icons-material/Layers';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import HomeIcon from '@mui/icons-material/Home';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CampaignIcon from '@mui/icons-material/Campaign';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import { Settings } from '@mui/icons-material';
import React from 'react';
import TodayIcon from '@mui/icons-material/Today';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PaymentsIcon from '@mui/icons-material/Payments';

const UserMgmt = React.lazy(() => import('../components/UsersManagement/UserMgmt'));
const Home = React.lazy(() => import('../components/Home/RoleAwareHome'));
const Course = React.lazy(() => import('../components/Course/Course'));
const Certificate = React.lazy(() => import('../components/Certificate/Certificate'));
const Enquiry = React.lazy(() => import('../components/Enquiry/Enquiry'));
const Main = React.lazy(() => import('../components/EditWebsite/Main'));
const OfferPage = React.lazy(() => import('../components/Offers/OfferPage'));
const Notice = React.lazy(() => import('../components/Notice/Notice'));
const Ebooks = React.lazy(() => import('../components/Ebooks/Ebooks'));
const MyCourses = React.lazy(() => import('../components/Student/MyCourses/MyCourses'));
const Schedule = React.lazy(() => import('../components/Schedule/Schedule'));
const MyTimetable = React.lazy(() => import('../components/Schedule/MyTimetable'));
const SeminarList = React.lazy(() => import('../components/Seminar/SeminarList'));
const SeminarForm = React.lazy(() => import('../components/Seminar/SeminarForm'));
const SeminarDetails = React.lazy(() => import('../components/Seminar/SeminarDetails'));
const AttendanceAdmin = React.lazy(() => import('../components/Attendance/AttendanceAdmin'));
const AttendanceDashboard = React.lazy(() => import('../components/Attendance/AttendanceDashboard'));
const ProfileDetails = React.lazy(() => import('../components/Global/ProfileDetails'));
const ContractsPage = React.lazy(() => import('../components/Contracts/ContractsPage'));
const SalesPerformancePanel = React.lazy(() =>
  import('../components/Home/RoleAwareHome').then((module) => ({ default: module.SalesPerformancePanel }))
);
const AuditLogPage = React.lazy(() => import('../components/Audit/AuditLogPage'));
const FeeCollectionPage = React.lazy(() => import('../components/Fee/FeeCollectionPage'));
const FeeOverduePage = React.lazy(() => import('../components/Fee/FeeOverduePage'));

// Define interface for the navigation item structure
export interface NavItem {
  title: string;
  path: string;
  icon?: React.ElementType;
  roles: string[];
  children?: NavItem[];
  element: React.ElementType; 
  section?: boolean;
}

// Array of navigation items with title, path, icon, and roles
const navItems: NavItem[] = [
  {
    title: 'Home',
    path: '/',
    icon: HomeIcon,
    roles: ["*"], 
    element: Home
  },
  {
    title: 'Sales Performance',
    path: '/sales-performance',
    icon: TrendingUpIcon,
    roles: ["ADMIN", "COUNSELLOR", "CENTER HEAD"],
    element: SalesPerformancePanel
  },
  {
    title: 'Contract Management',
    path: '/contracts',
    icon: DescriptionIcon,
    roles: ["ADMIN", "CENTER HEAD"],
    element: ContractsPage
  },
  {
    title: 'My Schedule',
    path: '/myschedule',
    icon: TodayIcon,
    roles: ["ADMIN", "COUNSELLOR", "CENTER HEAD", "FACULTY"],
    element: MyTimetable
  },
  {
    title: 'Enquiries',
    path: '/enquiry',
    icon: DescriptionIcon,
    roles: ['ADMIN', 'CENTER HEAD', 'COUNSELLOR'],
    element: Enquiry,
  },
  {
    title: 'Finance',
    path: '/fee-collection',
    icon: PaymentsIcon,
    roles: ['ADMIN', 'CENTER HEAD', 'COUNSELLOR'],
    element: FeeCollectionPage,
    children: [
      {
        title: 'Fee Collection',
        path: '/fee-collection',
        icon: PaymentsIcon,
        roles: ['ADMIN', 'CENTER HEAD', 'COUNSELLOR'],
        element: FeeCollectionPage,
      },
      {
        title: 'Overdue Fees',
        path: '/fee-overdue',
        icon: FactCheckIcon,
        roles: ['ADMIN', 'CENTER HEAD', 'COUNSELLOR'],
        element: FeeOverduePage,
      },
    ],
  },
  {
    title: 'Management',
    icon: Settings,
    path: "/svcs",
    element: ManageAccountsIcon,
    roles: ["*"],
    children: [
      {
        title: 'Manage Users',
        path: '/user-mgmt',
        icon: ManageAccountsIcon,
        roles: ["ADMIN","CENTER HEAD"], 
        element: UserMgmt
      },
      {
        title: 'Upload Ebooks',
        path: '/ebooks',
        roles: ["ADMIN", "MAINTAINER"],
        icon: UploadFileIcon,
        element: Ebooks
      },
      {
        title: 'Manage Notices',
        path: '/notice',
        roles: ["ADMIN", "MAINTAINER","CENTER HEAD"],
        icon: CampaignIcon,
        element: Notice
      },
      {
        title: 'Manage Schedule',
        path: '/timetable',
        icon: TodayIcon,
        roles: ["ADMIN", "COUNSELLOR", "CENTER HEAD"],
        element: Schedule
      },
      {
        title: 'Manage Offers',
        path: '/offer',
        roles: ["ADMIN"],
        icon: DomainVerificationIcon,
        element: OfferPage
      },
      {
        title: 'Website Pages',
        path: '/editwebsite',
        roles: ["ADMIN"],
        icon: EditNoteIcon,
        element: Main
      },
      {
        title: 'Audit Log',
        path: '/audit-log',
        icon: FactCheckIcon,
        roles: ['ADMIN'],
        element: AuditLogPage,
      },
    ],
  },
  {
  title: 'Seminars',
  path: '/seminars',
  icon: MenuBookIcon, // or another icon like SchoolIcon or EventNoteIcon
  roles: ["ADMIN", "CENTER HEAD","COUNSELLOR"],
  element: SeminarList,
  children: [
    {
      title: 'All Seminars',
      path: '/seminars',
      icon: VisibilityIcon,
      roles: ["ADMIN", "CENTER HEAD","COUNSELLOR"],
      element: SeminarList
    },
    {
      title: 'Create Seminar',
      path: '/seminars/add',
      icon: EditNoteIcon,
      roles: ["ADMIN", "COUNSELLOR"],
      element: SeminarForm,
    },
   
  ],
},

  {
    title: 'Courses',
    path: '/course',
    icon: AutoStoriesIcon,
    roles: ["ADMIN", "MAINTAINER"],
    element: Course
  },
  {
    title: 'Certificates',
    path: '/certificate',
    icon: WorkspacePremiumIcon,
    roles: ["ADMIN", "MAINTAINER","CERTIFICATE"],
    element: Certificate
  },
  // {
  //   title: 'Image Upload',
  //   path: '/img-upload',
  //   icon: LayersIcon,
  //   roles: ["ADMIN", "MAINTAINER"],
  // },

  {
    title: 'My Courses',
    path: '/my-courses',
    roles: ["ADMIN", "MAINTAINER","STUDENT","FACULTY"],
    icon: MenuBookIcon,
    element: MyCourses
  },
    {
      title: 'Attendance Management',
      path: '/attendance/admin',
      icon: EventAvailableIcon,
      roles: ["ADMIN", "CENTER HEAD", "COUNSELLOR"],
      element: AttendanceAdmin
    },
    {
      title: 'My Attendance',
      path: '/attendance/trainee',
      icon: EventAvailableIcon,
      roles: ["FACULTY"],
      element: AttendanceDashboard
    },
];

export const hiddenRoutes: NavItem[] = [
  {
    title: 'Profile',
    path: '/profile',
    roles: ['*'],
    element: ProfileDetails,
  },
  {
    title: 'Edit Seminar Details',
    path: '/seminars/edit/:id',
    roles: ['ADMIN', 'COUNSELLOR'],
    element: SeminarForm,
  },
  {
    title: 'View Seminar Details',
    path: '/seminars/:id',
    roles: ['ADMIN', 'COUNSELLOR', 'CENTER HEAD'],
    element: SeminarDetails,
  }
];

export default navItems;
